'use client';

import { useMemo } from 'react';

import type { ToolPartRenderer } from '@/features/copilot/model';

import { UpdateTextFieldToolCard } from './tools/update-text-field';

export function useCopilotToolPartRenderers(): Readonly<Record<string, ToolPartRenderer>> {
  // ZEKKA NOTE: Where are these strings centralized? This is spaghetti.
  // There should be an enum or something corresponding to "strings that can validly appear on the left hand side
  //  of this mapping."
  return useMemo(
    (): Record<string, ToolPartRenderer> => ({
      updateTextField: (props) => <UpdateTextFieldToolCard {...props} />,
    }),
    []
  );
}
